import isPlainObject from 'lodash/isPlainObject';
const convertToFields = (data, parentId) => {
    const keys = Object.keys(data);
    const reducer = (prev, current) => {
        const val = data[current];
        let key = current;
        if (parentId) {
            key = `${parentId}::${current}`;
        }
        if (isPlainObject(val) && Object.keys(val).length) {
            const nestedObj = convertToFields(val, key);
            return { ...prev, ...nestedObj };
        }
        return { ...prev, [key]: val };
    };
    return keys.reduce(reducer, {});
};
export default convertToFields;
